/****************************************************
 * Module Name:  AddLotCreationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, CircularProgress, TextField, Typography, Tooltip, Select as MuiSelect, FormControl, MenuItem } from "@mui/material";
import renderCellExpand from "../../common/dataGridCellExpand";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import LotIntimationProxy from "../../../utility/proxy/manager/manufacturingProxy/lotIntimationProxy";
import logo from '../../../images/pansuriya.jpg'
import dayjs from "dayjs";
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import TenderLotProxy from "../../../utility/proxy/manager/tender/tenderLotProxy";
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default class AddLotCreationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newDateReceive: new Date(),
      newCarat: this.props.editOperation ? this.props.sourceData.carats : "",
      newPcs: this.props.editOperation && this.props.sourceData.pcs ? this.props.sourceData.pcs : "",
      newPrice: "",
      newTotal: "",
      newLotintimationId: this.props.editOperation ? this.props.sourceData.lotintimationid : "",
      disableWeight: false,
      disablePcs: false,
      newInvoiceDate: new Date(),
      newInvoiceNo: "",
      newPaymentDate: null,
      newPaymentDays: "",
      currencyType: "USD",
      newCurrencyRate: "",
      showError: false,
      vendorOptions: [],
      showVendorLoadSpinner: true,

      validateLotCreationPresentSpinner: false,
      showValidationMessage: false,
      lotCreationAvailable: true,

      caratValidationError: "",
      pcsValidationError: "",
      paymentDaysValidationError: "",
      currencyRateValidationError: "",
      priceValidationError: "",
      lotintimationIdValidationError: "",
      tenderid: this.props.editOperation ? this.props.sourceData.tenderid : "",
      companyid: this.props.editOperation ? this.props.sourceData.companyid : "",
      tenderData: [],
      tenderDataLoader: false,
      selectionModel: [],
      isFromTender: this.props.sourceData.tenderid !== undefined && this.props.sourceData.tenderid !== "" && this.props.sourceData.tenderid !== null ? true : false,
      applyValue: 0,
      applyToAll: "ppc",
      newppc: 0,
      newtotal: 0,
    };
  }

  componentDidMount() {
    if (this.state.isFromTender) {
      this.getTenderData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.tenderid !== prevState.tenderid &&
      this.state.tenderid !== "" &&
      this.state.tenderid !== null
    ) {
      this.getTenderData();
    }
  }

  getTenderData = () => {
    this.setState({ tenderDataLoader: true, });
    let lotintimationid = this.props.sourceData.lotintimationid ? this.props.sourceData.lotintimationid : this.state.newLotintimationId;
    TenderLotProxy.GetCompletedLotData(this.state.tenderid, this.state.companyid, true, "LOCKED", "LOCKED", lotintimationid, (response) => {
      if (response) {
        this.setState({
          tenderData: response,
          tenderDataLoader: false,
          selectionModel: response.map(iData => iData.tenderlotid),
        });
      }
    });
  }

  handleSave = () => {
    let selectedTenderLots = {};
    if (this.state.isFromTender) {
      selectedTenderLots = this.state.tenderData
        .filter(row => this.state.selectionModel.includes(row.tenderlotid))
        .map(row => ({
          tenderlotid: row.tenderlotid,
          pcs: row.pcs,
          carats: row.carats,
          price: row.newppc,
          total: row.newtotal,
        }));
    }
    let data = {
      carats: this.state.newCarat,
      price: this.state.newPrice,
      pcs: this.state.newPcs,
      total: this.state.newTotal,
      date:
        Utility.ConvertLocalTimeToUtc(new Date()).slice(0, 11) +
        "00:00:00.000Z",
      datereceived:
        Utility.ConvertLocalTimeToUtc(this.state.newDateReceive).slice(0, 11) +
        "00:00:00.000Z",
      lotintimationid: Number(this.state.newLotintimationId),
      tenderid: this.state.tenderid,
      invoicedate:
        Utility.ConvertLocalTimeToUtc(this.state.newInvoiceDate).slice(0, 11) +
        "00:00:00.000Z",
      invoiceno: this.state.newInvoiceNo,
      paymentdate:
        Utility.ConvertLocalTimeToUtc(this.state.newPaymentDate).slice(0, 11) +
        "00:00:00.000Z",
      paymentdays: this.state.newPaymentDays,
      currencytype: this.state.currencyType,
      currencyrate: this.state.newCurrencyRate,
      tenderlotdata: this.state.isFromTender ? selectedTenderLots : [],
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLotCreationPresent = (lotCreationEntered) => {
    if (!lotCreationEntered || lotCreationEntered.trim() === "") {
      this.setState({
        isFromTender: false,
        showValidationMessage: false,
      });
      return
    };

    this.setState({
      validateLotCreationPresentSpinner: true,
    });

    LotIntimationProxy.GetSingleLotIntimation(
      lotCreationEntered,
      (response) => {

        //if we got response that means lotCreation is present at backend
        if (response && !response.received) {
          //LotCreationName already present
          this.setState({
            validateLotCreationPresentSpinner: false,
            showValidationMessage: true,
            lotCreationAvailable: true,
            newCarat: response.carats ? response.carats : "",
            newPcs: response.pcs ? response.pcs : "",
            disableWeight: true,
            disablePcs: response.pcs ? true : false,
            tenderid: response.tenderid,
            companyid: response.companyid,
            isFromTender: true,
          });
          if (response.carats)
            this.handleUpdateCarat(response.carats);
        } else {
          //LotCreationName not available, so can be used
          this.setState({
            validateLotCreationPresentSpinner: false,
            showValidationMessage: true,
            lotCreationAvailable: false,
            isFromTender: false,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    const isSelectionEmpty = this.state.selectionModel.length === 0;

    const tenderValidationFailed = this.state.isFromTender && (
      isSelectionEmpty ||
      this.state.selectionModel.some(id => {
        const row = this.state.tenderData.find(r => r.tenderlotid === id);
        return !row || !row.newppc || !row.newtotal;
      })
    );

    // If not from tender, check top-level fields for price/total
    const normalValidationFailed = !this.state.isFromTender && (
      this.state.priceValidationError.length !== 0 ||
      this.state.newPrice.length === 0 ||
      this.state.newTotal.length === 0
    );
    return (
      normalValidationFailed ||
      tenderValidationFailed ||
      this.state.newCarat.length === 0 ||
      this.state.newPcs.length === 0 ||
      this.state.pcsValidationError.length !== 0 ||
      this.state.lotintimationIdValidationError.length !== 0 ||
      this.state.newLotintimationId.length === 0 ||
      !this.state.lotCreationAvailable ||
      this.state.newDateReceive.length === 0 ||
      this.state.newInvoiceDate.length === 0 ||
      this.state.newInvoiceNo.length === 0 ||
      this.state.newPaymentDate === null ||
      this.state.newPaymentDays.length === 0 ||
      this.state.currencyType.length === 0 ||
      this.state.newCurrencyRate.length === 0
    )
  };

  handleUpdateCarat(carats) {
    const size = parseFloat(carats);
    const pricePerCarat = parseFloat(this.state.newPrice);
    const total = parseFloat(this.state.newTotal);

    if (pricePerCarat) {
      this.setState({ newTotal: parseFloat((Number(pricePerCarat) * Number(size)).toFixed(2)) });
    } else if (total) {
      this.setState({ newPrice: parseFloat((Number(total) / size).toFixed(2)) });
    }
  }


  columns = [
    {
      field: 'tenderlotid',
      headerName: 'ID',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
      width: 60
    },
    {
      field: 'tenderid',
      headerName: 'TENDER ID',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
      width: 70
    },
    {
      field: 'tendername',
      headerName: 'TENDER NAME',
      headerAlign: 'center',
      align: 'center',
      renderCell: renderCellExpand,
      width: 110
    },
    {
      field: 'carats',
      headerName: 'CTS',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
      width: 60
    },
    {
      field: 'description',
      headerName: 'DESCRIPTION',
      headerAlign: 'center',
      align: 'center',
      renderCell: renderCellExpand,
      width: 140
    },
    {
      field: 'mineid',
      headerName: 'MINE ID',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
      width: 70
    },
    {
      field: 'pcs',
      headerName: 'PCS',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
      width: 40
    },
    {
      field: 'size',
      headerName: 'SIZE',
      headerAlign: 'center',
      align: 'center',
      renderCell: renderCellExpand,
      width: 60
    },
    {
      field: 'resultppc',
      headerName: 'RESULT PPC',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value ? (params.value).toFixed(2) : 0,
      renderCell: (params) => params.value ? (params.value).toFixed(2) : 0,
      width: 92,
    },
    {
      field: 'bidwonlostamount',
      headerName: 'RESULT AMT',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      valueFormatter: (params) => params.value ? (params.value).toFixed(2) : 0,
      renderCell: (params) => params.value ? (params.value).toFixed(2) : 0,
      width: 92,
    },
    {
      field: "newppc",
      headerName: "NEWPPC",
      headerAlign: "center",
      align: "center",
      width: 85,
      editable: true,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>{params.value}</span>
          {params.colDef.editable && <EditIcon style={{ marginLeft: 5, marginBottom: 3, fontSize: '1rem' }} />}
        </div>
      ),
      cellClassName: (params) => 'lavenderCell',
    },
    {
      field: "newtotal",
      headerName: "NEWTOTAL",
      headerAlign: "center",
      align: "center",
      width: 85,
      editable: true,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>{params.value}</span>
          {params.colDef.editable && <EditIcon style={{ marginLeft: 5, marginBottom: 3, fontSize: '1rem' }} />}
        </div>
      ),
      cellClassName: (params) => 'lavenderCell',
    },
  ];

  // KEEP THIS 
  // onRowSelectionModelChange = (newSelectionModel) => {
  //   const { tenderData, newPrice } = this.state;
  //   const selectedRows = tenderData.filter(row =>
  //     newSelectionModel.includes(row.tenderlotid)
  //   );
  //   const carats = selectedRows.reduce((sum, row) => sum + (parseFloat(row.carats) || 0), 0);
  //   const pcs = selectedRows.reduce((sum, row) => sum + (parseFloat(row.pcs) || 0), 0);
  //   const total = newPrice && carats
  //     ? parseFloat((Number(newPrice) * carats).toFixed(2))
  //     : "";

  //   this.setState({
  //     selectionModel: newSelectionModel,
  //     newCarat: carats,
  //     newPcs: pcs,
  //     newTotal: total
  //   });
  // };

  getChangedFields = (newRow, oldRow) => {
    const changedFields = [];

    Object.keys(newRow).forEach(field => {
      if (newRow[field] !== oldRow[field]) {
        changedFields.push({
          id: newRow.tenderlotid,
          field: field,
          value: typeof newRow[field] === 'string' ? newRow[field].trim() : newRow[field]
        });
      }
    });

    return changedFields;
  };

  handleProcessRowUpdateError = (error) => {
    // console.error(error);
  };

  processRowUpdate = (newR, oldRow) => {
    const changedFeilds = this.getChangedFields(newR, oldRow);
    if (changedFeilds.length > 0) {
      const { id, field, value } = changedFeilds[0];
      let newRow = { ...oldRow };
      const updatedListData = this.state.tenderData.map(row => {
        if (row.tenderlotid === id) {
          if (field === "newtotal" && parseFloat(value) !== parseFloat(row.newtotal)) {
            newRow = {
              ...row,
              [field]: parseFloat(value).toFixed(2),
            };
            const newppc = parseFloat((parseFloat(value) / row.carats)).toFixed(2);
            newRow.newppc = newppc;
          }
          if (field === 'newppc' && parseFloat(value) !== parseFloat(row.newppc)) {
            newRow = {
              ...row,
              [field]: parseFloat(value).toFixed(2),
            };
            const newtotal = parseFloat((parseFloat(value) * row.carats)).toFixed(2);
            newRow.newtotal = newtotal;
          }
          return newRow;
        }
        return row;
      });
      this.setState({
        tenderData: updatedListData,
      });
      return newRow;
    } else {
      // No changes detected, return the newRow to trigger exit edit mode
      return { ...newR };
    }
  }

  applyValueToAllFields = () => {
    if (this.state.tenderData.length > 0) {
      const updatedListData = this.state.tenderData.map(row => {
        if (this.state.applyToAll === "ppc") {
          const newppc = parseFloat(this.state.applyValue).toFixed(2);
          const newtotal = parseFloat((parseFloat(newppc) * row.carats)).toFixed(2);
          return {
            ...row,
            newppc: newppc,
            newtotal: newtotal,
          };
        }
        else if (this.state.applyToAll === "total") {
          const newtotal = parseFloat(this.state.applyValue).toFixed(2);
          const newppc = parseFloat((parseFloat(newtotal) / row.carats)).toFixed(2);
          return {
            ...row,
            newppc: newppc,
            newtotal: newtotal,
          };
        }
        return row;
      });
      this.setState({
        tenderData: updatedListData,
      });
    }
  };

  getSelectedCaratsTotal = () => {
    const { tenderData, selectionModel } = this.state;
    if (!selectionModel || selectionModel.length === 0) return this.props.sourceData.carats;

    const selectedRows = tenderData.filter(row =>
      selectionModel.includes(row.tenderlotid)
    );
    const newCarat = selectedRows.reduce((sum, row) => sum + (parseFloat(row.carats) || 0), 0);
    return newCarat;
  };

  getSelectedPcsTotal = () => {
    const { tenderData, selectionModel } = this.state;
    if (!selectionModel || selectionModel.length === 0) return this.props.sourceData.pcs;

    const selectedRows = tenderData.filter(row =>
      selectionModel.includes(row.tenderlotid)
    );

    return selectedRows.reduce((sum, row) => sum + (parseFloat(row.pcs) || 0), 0);
  };


  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />

          <Box sx={{ flexGrow: 1, display: "block" }} />
          {this.state.tenderDataLoader ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.getTenderData()}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      )
    }
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add Lot Creation validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false} dialogClassName="lotCreationModal">
          <Modal.Header closeButton>
            <Modal.Title>
              <img src={logo} height="40pt" width="40pt" alt={Constants.COMPANY_SITE} />
              &nbsp;&nbsp;
              {"Add New Lot Creation"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, width: "100%" }}>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Lot Int Id <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation ? (
                  <Typography>{this.props.sourceData.lotintimationid}</Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="Enter Lot Int Id"
                    value={this.state.newLotintimationId}
                    disabled={this.props.disabled}
                    onBlur={() => this.validateLotCreationPresent(this.state.newLotintimationId)}
                    onChange={(e) => this.setState({
                      newLotintimationId: e.target.value,
                      lotintimationIdValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Lot Int Id Should be a positive number",
                    })}
                    helperText={this.state.lotintimationIdValidationError}
                    error={this.state.lotintimationIdValidationError.length > 0}
                  />
                )}
                {this.state.showValidationMessage && (
                  <Box sx={{ marginTop: "8px" }}>
                    {this.state.validateLotCreationPresentSpinner ? (
                      <CircularProgress size="1rem" />
                    ) : this.state.lotCreationAvailable ? (
                      <Typography sx={{ color: "green", fontSize: "0.875rem" }}>
                        Lot Intimation is present
                      </Typography>
                    ) : (
                      <Typography sx={{ color: "red", fontSize: "0.875rem" }}>
                        Lot Intimation is not present
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Date Received<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newDateReceive}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newDateReceive = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      this.setState({ newDateReceive });
                    }}
                    maxDate={new Date()}
                  />
                </LocalizationProvider>
              </Box>

              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Price Per Carat <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Price Per Carat"
                  value={this.state.newPrice}
                  disabled={this.state.isFromTender}
                  onChange={(e) => {
                    const pricePerCarat = e.target.value;
                    const carats = this.state.isFromTender ? this.getSelectedCaratsTotal().toFixed(2) : this.state.newCarat ? parseFloat(this.state.newCarat) : null;
                    const total = carats ? parseFloat((Number(pricePerCarat) * carats).toFixed(2)) : this.state.newTotal;
                    this.setState({
                      newPrice: pricePerCarat,
                      newTotal: total,
                      priceValidationError: Utility.CheckisNumberPositive(pricePerCarat)
                        ? "" : "Price Per Carat Should be a positive number",
                    });
                  }}
                  helperText={this.state.priceValidationError}
                  error={this.state.priceValidationError.length > 0}
                />
              </Box>

              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Total <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Total"
                  value={this.state.newTotal}
                  disabled={this.state.isFromTender}
                  onChange={(e) => {
                    const totalValue = e.target.value;
                    const carats = this.state.isFromTender ? this.getSelectedCaratsTotal().toFixed(2) : this.state.newCarat ? parseFloat(this.state.newCarat) : null;
                    const pricePerCarat = carats ? parseFloat((Number(totalValue) / carats).toFixed(2)) : this.state.newPrice;
                    this.setState({ newTotal: totalValue, newPrice: pricePerCarat });
                  }}
                />
              </Box>

              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Carats <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation ? (
                  <Typography>{this.state.isFromTender ? this.getSelectedCaratsTotal().toFixed(2) : this.props.sourceData.carats}</Typography>
                ) : this.state.disableWeight ? (
                  <Typography>{this.state.newCarat}</Typography>
                ) : <Typography>-</Typography>}
              </Box>

              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Pcs <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation && this.props.sourceData.pcs ? (
                  <Typography>{this.state.isFromTender ? this.getSelectedPcsTotal() : this.props.sourceData.pcs}</Typography>
                ) : this.state.disablePcs && this.state.newPcs !== "" ? (
                  <Typography>{this.state.newPcs}</Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="Enter Pcs"
                    value={this.state.newPcs !== "" ? this.state.newPcs : 0}
                    onChange={(e) =>
                      this.setState({
                        newPcs: e.target.value,
                        pcsValidationError: Utility.CheckisNumberPositive(e.target.value)
                          ? "" : "Pcs Should be a positive number",
                      })
                    }
                    helperText={this.state.pcsValidationError}
                    error={this.state.pcsValidationError.length > 0}
                  />
                )}
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Invoice Date<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newInvoiceDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newInvoiceDate = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let newPaymentDate = dayjs(this.state.newPaymentDate).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let newPaymentDays = this.state.newPaymentDays;

                      if (newPaymentDate < newInvoiceDate) {
                        newPaymentDays = "";
                        newPaymentDate = null;
                      }
                      else if (newPaymentDate) {
                        newPaymentDays = dayjs(newPaymentDate).diff(newInvoiceDate, "day");
                      } else if (newPaymentDays) {
                        newPaymentDate = dayjs(newInvoiceDate).add(Number(newPaymentDays), "day").toDate();
                      }

                      this.setState({ newInvoiceDate, newPaymentDate, newPaymentDays });
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Invoice No. <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter Invoice No"
                  value={this.state.newInvoiceNo}
                  onChange={(e) =>
                    this.setState({
                      newInvoiceNo: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Payment Date<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newPaymentDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newPaymentDate = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let { newInvoiceDate } = this.state;
                      let newPaymentDays = this.state.newPaymentDays;

                      if (newPaymentDate < newInvoiceDate) {
                        newPaymentDays = "";
                        newInvoiceDate = null;
                      }
                      else if (newInvoiceDate) {
                        newPaymentDays = dayjs(newPaymentDate).diff(newInvoiceDate, "day");
                      } else if (newPaymentDays) {
                        newInvoiceDate = dayjs(newPaymentDate).subtract(Number(newPaymentDays), "day").toDate();
                      }

                      this.setState({ newPaymentDate, newInvoiceDate, newPaymentDays });
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Payment Days <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Payment Days"
                  value={this.state.newPaymentDays}
                  onChange={(e) => {
                    const newPaymentDays = e.target.value;

                    const { newInvoiceDate, newPaymentDate } = this.state;
                    let updatedPaymentDate = newPaymentDate;
                    let updatedInvoiceDate = newInvoiceDate;

                    if (newInvoiceDate) {
                      updatedPaymentDate = dayjs(newInvoiceDate).add(Number(newPaymentDays), "day").toDate();
                    } else if (newPaymentDate) {
                      updatedInvoiceDate = dayjs(newPaymentDate).subtract(Number(newPaymentDays), "day").toDate();
                    }

                    this.setState({
                      newPaymentDays, newPaymentDate: updatedPaymentDate, newInvoiceDate: updatedInvoiceDate,
                      paymentDaysValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Payment Days Should be a positive number",
                    });
                  }
                  }
                />
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Currency Type <sup style={{ color: "red" }}>*</sup></Typography>
                <Select
                  options={Constants.CURRENCY_TYPE}
                  value={Constants.CURRENCY_TYPE.find(option => option.value === this.state.currencyType)}
                  onChange={(selectedOption) => this.setState({ currencyType: selectedOption.value })}
                  placeholder="Select Currency"
                />
              </Box>
              <Box sx={{ flex: this.state.isFromTender ? "1 1 20%" : "1 1 30%" }}>
                <Typography>Currency Rate <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Currency Rate"
                  value={this.state.newCurrencyRate}
                  onChange={(e) =>
                    this.setState({
                      newCurrencyRate: e.target.value,
                      currencyRateValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Currency Rate Should be a positive number",
                    })
                  }
                />
              </Box>
            </Box>
            {this.state.isFromTender && (
              <Box px={1} mt={4} sx={{ position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    right: "9px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "& .MuiInputBase-input": {
                      padding: "4px 8px !important",
                      width: "6.8rem"
                    },
                    "& .MuiInputLabel-root[data-shrink='false']": {
                      top: "-6px !important",
                      color: "rgba(0, 0, 0, 0.4) !important",
                    },
                    "& .MuiTextField-root": {
                      marginTop: 0,
                      marginBottom: 0
                    }
                  }}
                >
                  <FormControl sx={{ width: "7.7rem" }}>
                    <MuiSelect
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          padding: "6px 12px 7px",
                          lineHeight: "1.5",
                        },
                      }}
                      labelId="select-label"
                      value={this.state.applyToAll}
                      onChange={(event) => this.setState({ applyToAll: event.target.value })}
                    >
                      <MenuItem value="ppc">PPC</MenuItem>
                      <MenuItem value="total">TOTAL</MenuItem>
                    </MuiSelect>
                  </FormControl>
                  <TextField
                    margin="normal"
                    placeholder="Enter Value"
                    value={this.state.applyValue}
                    onChange={(e) => this.setState({ applyValue: e.target.value })}
                  />
                  <LoadingButton
                    variant="contained"
                    onClick={this.applyValueToAllFields}
                    type="submit"
                    color="success"
                    loadingPosition="start"
                    startIcon={<CheckCircleIcon />}
                    sx={{ width: "105px", height: "31px" }}
                    disabled={!this.state.applyValue}
                  >
                    Apply
                  </LoadingButton>
                </Box>
              </Box>
            )}
            {(this.state.isFromTender) && (
              <Box px={1} mt={10}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    width: "100%",
                    position: "relative",
                    "& .MuiTablePagination-selectLabel": {
                      marginTop: "15px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginTop: "15px",
                    },
                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    "& .css-cc8tf1": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    height: "37vh",
                  }}
                >
                  <DataGridPro
                    disableRowSelectionOnClick={true}
                    sx={{
                      '& .MuiDataGrid-columnHeader': {
                        color: '#fff',
                        backgroundColor: 'grey',
                      },
                      "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                        py: "4px",
                      },
                      "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                        py: "12px",
                      },
                      "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                        py: "18px",
                      },
                      "& .lavenderCell": {
                        color: "#080808",
                        backgroundColor: "#D8BFD8",
                      },
                      fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                    }}
                    density="compact"
                    slots={{ toolbar: CustomToolbar }}
                    rows={this.state.tenderData}
                    columns={this.columns}
                    getRowId={(row) => row.tenderlotid}
                    loading={this.state.tenderDataLoader}
                    checkboxSelection={true}
                    onRowSelectionModelChange={(newSelectionModel) => this.setState({ selectionModel: newSelectionModel })}
                    rowSelectionModel={this.state.selectionModel}
                    processRowUpdate={this.processRowUpdate}
                    onProcessRowUpdateError={this.handleProcessRowUpdateError}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          tenderlotid: false,
                          tenderid: false,
                        },
                      },
                      pagination: {
                        paginationModel: Constants.pageSize,
                      },
                    }}
                    pageSizeOptions={Constants.pageSizeOptions}
                    pagination
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                </Box>
              </Box>
            )}
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Receive
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
